<template>
    <div>
        <selector class="custom-select" :value="value" :placeholder="placeholder" max-height="asdf" transition="expand" :options="options" @input="inputUpdate($event)" :searchable="searchable" :inputId="inputId" :class="[ selected ? 'selected' : '', passThroughClass ? passThroughClass : ''  ]" :disabled="disabled"></selector>
    </div>
</template>

<script>
    import Selector from '@/components/forks/select';

    export default {
        model: {
            prop: 'selectedCreative',
            event: 'cha',
        },
        props: [
            'inputId',
            'label',
            'options',
            'placeholder',
            'value',
            'searchable',
            'disabled',
            'passThroughClass',
        ],
        data() {
            return {
                selected: false,
            };
        },
        components: {
            Selector,
        },
        methods: {
            inputUpdate(e) {
                // const name = this.name;
                let value = null;

                if (e && e.value) {
                    value = e.value;
                } else {
                    value = e;
                }

                if (value === null) {
                    this.selected = false;
                } else {
                    this.selected = true;
                }

                this.$emit('input', value);
            },
        },
    };
</script>

<style lang="scss">
    @import '../../assets/scss/partials/variables';
    @import '../../assets/scss/partials/mixins';

    .v-select.custom-select.single,
    .v-select.custom-select {
        background-color: $kpmg-blue;
        transition: background-color 0.6s ease;

        z-index: 1;

        &.disabled {
            .dropdown-toggle,
            .dropdown-toggle .clear,
            .dropdown-toggle input,
            .selected-tag .close,
            .open-indicator {
                background-color: hsla(218, 35%, 83%, 0.64);
            }

            &.unsearchable input[type="search"]:hover {
                cursor: not-allowed;
            }
        }

        input::placeholder {
            color: white;
        }

        input:-ms-input-placeholder {
            color: white;
        }

        .clear {
            height: 100%;
            width: 34px;
            bottom: 0;
            right: 40px;

            background-image: url('../../assets/images/icons/icon-close.svg');
            background-size: 18px 18px;
            background-repeat: no-repeat;
            background-position: center;

            span {
                display: none;
            }
        }

        &.unsearchable input[type=search] {
            opacity: 1;
        }

        input[type=search],
        input[type=search]:focus {
            height: 40px;
            font-size: 12px;

            position: absolute;
            top: 0;
            left: 0;

            padding-left: 11px;
        }

        .open-indicator {
            height: 40px;
            width: 40px;
            top: 0;
            right: 0;
            background-color: rgba(255, 255, 255, 0.1);

            transition-timing-function: ease;

            &::before {
                border: 0;
                background-image: url('../../assets/images/icons/icon-dropdown-open.svg');
                height: 12px;
                width: 16px;
                transform: translate(-50%, -50%);
                transition-timing-function: ease;
                transition-duration: 0.5s;
                top: 50%;
                left: 50%;
                position: absolute;
                transform-origin: 25% 0px;
            }
        }

        .dropdown-toggle {
            height: 40px;
            padding-right: 80px;
            border-radius: 0;
            border: 0;
        }

        .dropdown-menu {
            padding: 0;
            background-color: #dbe6fa;
            font-size: 12px;
            letter-spacing: 0.6px;
            color: $greyish-brown;
            max-height: 400px;
            max-width: 300px;
            width: auto;
            min-width: 100%;
            overflow-y: auto;

            transition:opacity 1s ease;

            > li {
                padding: 0;
                a {
                    padding: 14px 13px 13px 10px;
                    background-color: transparent;
                    color: $greyish-brown;
                    white-space: normal;
                    line-height: 1.3;
                }
            }

            .highlight {
                position: relative;
                background-color: #c1d3f3;
            }

            .active {
                position: relative;
                background-color: transparentize($kpmg-purple, 0.7);
            }

            &.expand-enter-active {
                transition-property: max-height, max-width;
                transition-duration: 1s, 1s;
                transition-timing-function:  ease;
            }

            &.expand-leave-active {
                transition-property: max-height, max-width;
                transition-duration: 0.5s, 0.5s;
                transition-timing-function:  ease;
            }

            &.expand-leave-to,
            &.expand-enter {
                max-height: 0;
                max-width: 0;
            }
            &.expand-leave,
            &.expand-enter-to {
                max-height: 400px;
                max-width: 300px;
            }
        }

        &.Placement,
        &.Creative {
            .dropdown-menu {
                min-width: 300px;

                &.expand-enter-active {
                    transition-property: max-height, max-width, min-width;
                    transition-duration: 1s, 1s, 1s;
                    transition-timing-function:  ease;
                }

                &.expand-leave-active {
                    transition-property: max-height, max-width, min-width;
                    transition-duration: 0.5s, 0.5s, 0.5s;
                    transition-timing-function:  ease;
                }

                &.expand-leave-to,
                &.expand-enter {
                    max-height: 0;
                    max-width: 0;
                    min-width: 0;
                }
                &.expand-leave,
                &.expand-enter-to {
                    max-height: 400px;
                    max-width: 300px;
                    min-width: 300px;
                }
            }
        }

        .selected-tag {
            display: inline-block;
            width: 100%;
            height: 40px;
            color: white;
            font-size: 12px;
            line-height: 14px;
            float: none;
            margin: 0;
            padding: 13px 0 13px 11px;
            border: 0;
            border-radius: 0;
            letter-spacing: 0.6px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;

            @include fontArial();

            // background-color: $kpmg-purple;
                max-width: 261px;

            &.tagAppear-enter-active {
                transition: max-width 0.5s ease;
                +  input[type=search] {
                    transition: opacity 0.5s ease;
                }
            }

            &.tagAppear-leave-active {
                transition: max-width 0.5s ease;
                +  input[type=search] {
                    transition: opacity 0.5s ease 0.5s;
                }
            }

            &.tagAppear-leave-to,
            &.tagAppear-enter {
                max-width: 0px;
                +  input[type=search] {
                    opacity: 1;
                }
            }

            &.tagAppear-leave,
            &.tagAppear-enter-to {
                max-width: 261px;
                +  input[type=search] {
                    opacity: 0;
                }
            }

            + input[type=search] {
                opacity: 0;
            }
        }

        &.open {
            .open-indicator {
                bottom: auto;

                &::before {
                    transform: translate(-50%, 40%) rotateX(180deg);
                }
            }

            &.single {
                .selected-tag {
                    position: static;
                    opacity: 1;
                }
            }
        }

        &.selected {
            background-color: $kpmg-purple;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/filters/SelectInput.vue